import React, {Fragment} from 'react';
import styled from 'styled-components'
import ArrowIcon from './icon/arrow'
import {slideRight, slideLeft, overlaySlideLeft, overlaySlideOff} from "./keyframes";


const ButtonText = styled.div`
        color: ${props => props.color};
        font-size: ${props => props.fontSize};
        fill: ${props => props.fontHoverColor};
        animation-name: ${slideRight};
        animation-duration: 1s;
        animation-direction: normal;
        animation-fill-mode: forwards;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-45%, -50%);
        z-index: 3;
        svg {
            opacity:0;
            margin-left:4px;
            width: 20px;
            }
    `

const ButtonOverlay = styled.div`
        background-color: ${props => props.backgroundColor};
        animation-name: ${overlaySlideOff};
        animation-duration: 1s;
        animation-direction: normal;
        animation-fill-mode: forwards;
        width: 450px;
        height: 350px;
        position: absolute;
        top: -400px;
        right: -250px;
        transform: rotate(50deg);
        z-index: 0;
    `;




const ButtonContainer = styled.div`
        background-color: ${props => props.btnBgColor};
        border-color: ${props => props.borderColor};
        width: ${props => props.buttonWidth};
        height:${props => props.buttonHeight};
        position: relative;
        font-size: 14px;
        font-weight: 300;
        white-space: nowrap;
        border-width: ${props => props.borderWidth};
        border-style: solid;
        overflow: hidden;
        z-index: 1;
            &:hover {
            border-color: ${props => props.btnHoverColor};
            cursor: pointer;
                ${ButtonText} {
                    color: ${props => props.fontHoverColor};
                    animation-name: ${slideLeft};
                    animation-duration: 1s;
                    animation-direction: normal;
                    animation-fill-mode: forwards;
                    svg {opacity: 1;}
                    }
                ${ButtonOverlay}{
                      animation-name:${overlaySlideLeft};
                      animation-duration: 1s;
                      animation-direction: normal;
                      animation-fill-mode: forwards;
                    }  
                  
                }`;

const Button = (props) => {

    const btn_text = props.buttonText;
    const btn_bg_color = props.buttonColorBg;
    const btn_hover_color = props.buttonHoverColor;
    const font_color = props.fontColor;
    const font_hover_color = props.fontHoverColor;
    const font_size = props.fontSize;
    const link = props.linkDestination;
    const _target = props.linkTarget;
    const arrow_color = props.arrowColor;
    const button_width = props.buttonWidth;
    const button_height = props.buttonHeight;
    const border_width = props.buttonBorderWidth;
    const external = props.external || false;
    const submit = props.submit || false;




    const goToLink = () => {
        if (submit) {
            props.callback()
        }
        if (external) {
            window.open(link, _target);
        } else {

            document.querySelector('.question-container').scrollIntoView({
                behavior: 'smooth'
            });
        }

    };

    return (
        <Fragment>
            <ButtonContainer btnBgColor={btn_bg_color}
                             borderColor={font_color}
                             btnHoverColor={btn_hover_color}
                             fontHoverColor={font_hover_color}
                             arrowColor={arrow_color}
                             buttonWidth={button_width}
                             buttonHeight={button_height}
                             borderWidth={border_width}
                             onClick={goToLink}>
                <ButtonOverlay backgroundColor={btn_hover_color} buttonWidth={button_width}/>
                <ButtonText color={font_color}
                            fontHoverColor={font_hover_color}
                            fontSize={font_size}>
                    {btn_text}
                    <ArrowIcon/>
                </ButtonText>
            </ButtonContainer>
        </Fragment>
    );
}

export default Button;
